export default __webpack_public_path__ + "static/media/sceduler.b35b0002.svg";